"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var cookieTypes = {
  saleOfPersonalData: 'SPD_BG',
  analyticsPerformance: 'C0002',
  marketingTargeting: 'C0004',
  marketingSocialMedia: 'C0005'
};
function sendConsent() {
  var activeGroups = window.OnetrustActiveGroups || [];
  var setConsent = function setConsent(type, value) {
    window.Shopify.customerPrivacy.setTrackingConsent(_defineProperty({}, type, value), function () {});
  };
  setConsent('sale_of_data', activeGroups.includes(cookieTypes.saleOfPersonalData));
  setConsent('analytics', activeGroups.includes(cookieTypes.analyticsPerformance));
  var marketingConsentValue = activeGroups.includes(cookieTypes.marketingTargeting) && activeGroups.includes(cookieTypes.marketingSocialMedia);
  setConsent('marketing', marketingConsentValue);
}
function optanonWrapper() {
  window.Shopify.loadFeatures([{
    name: 'consent-tracking-api',
    version: '0.1'
  }], function (error) {
    if (error) {
      throw error;
    }
    sendConsent();
  });
}
function hasOneTrustLoaded() {
  if (typeof window.OnetrustActiveGroups === 'string') {
    //check now
    optanonWrapper();
    // and wrap and trigger after cookie opt-in
    window.OptanonWrapper = optanonWrapper;
    return true;
  }
  return false;
}
function waitForOneTrust() {
  hasOneTrustLoaded();
  var attempts = 0;
  var interval = setInterval(function () {
    if (hasOneTrustLoaded() || attempts > 100) {
      clearInterval(interval);
    }
    attempts++;
  }, 100);
}
waitForOneTrust();